import { h, Component } from 'preact';
import { joinClasses, sortObjectByOrder } from 'utils/utils';

import Store from 'store/store';

import Facebook from 'components/bolt/icons/facebook';
import Bluesky from 'components/bolt/icons/bluesky';
import Twitter from 'components/bolt/icons/twitter';
import Twitch from 'components/bolt/icons/twitch';
import Instagram from 'components/bolt/icons/instagram';
import Youtube from 'components/bolt/icons/youtube';
import Snapchat from 'components/bolt/icons/snapchat';
import Tiktok from 'components/bolt/icons/tiktok';
import Spotify from 'components/bolt/icons/spotify';
import Pinterest from 'components/bolt/icons/pinterest';
import Giphy from 'components/bolt/icons/giphy';
import Tumblr from 'components/bolt/icons/tumblr';
import Vimeo from 'components/bolt/icons/vimeo';
import Mail from 'components/bolt/icons/mail';
import Threads from 'components/bolt/icons/threads';

import Link from 'components/bolt/link/link';

import s from 'components/bolt/socials/socials.sss';

// TODO: dynamic import
const icons = {
	facebook: Facebook,
	bluesky: Bluesky,
	twitter: Twitter,
	twitch: Twitch,
	instagram: Instagram,
	youtube: Youtube,
	snapchat: Snapchat,
	tiktok: Tiktok,
	spotify: Spotify,
	pinterest: Pinterest,
	giphy: Giphy,
	tumblr: Tumblr,
	vimeo: Vimeo,
	email: Mail,
	threads: Threads,
};

export default class Socials extends Component {
	getIcon(id, data) {
		const props = this.props;
		const Icon = icons[id];
		const attr = { class: props.iconStyle || s.icon };
		if (!Icon) {
			if (data.iconURL) {
				const src = (props.navOpen && data.iconNav) ? data.iconNav : data.iconURL;
				return <img {...attr} src={src} alt="" />;
			}
			return null;
		}
		return <Icon {...attr} />;
	}

	render(props) {
		const { socials = {}, navOpen } = props;

		const accessibilityCopy = Store.get().appData?.copy?.accessibilityCopy;
		return (
			<div class={joinClasses(s.socials, props.class, navOpen && s.navOpen)}>
				{sortObjectByOrder(socials, (social, id) => (
					<Link
						class={joinClasses(!props.iconStyle && s.social, s[id])}
						href={social.destination}
						target="_blank"
						rel="noopener noreferrer"
						key={id}
						onClick={() => Store.emit('CLICKED_FOLLOW', id, { url: social.destination })}
						ariaLabel={accessibilityCopy?.$SOCIAL_ARIA?.replace('<platform>', id)}
					>
						{this.getIcon(id, social)}
					</Link>
				)).slice(0, 5)}
			</div>
		);
	}
}
